// Figma glass modal: Dialog and AlertDialog already give the card; these set its spacing and type.
export const DIALOG_CONTENT_CLASS = 'max-w-[420px] gap-0 p-0';
export const DIALOG_HEADER_CLASS = 'gap-1.5 px-5 pt-4 pb-3 text-left';
export const DIALOG_TITLE_CLASS = 'text-[16px] leading-6';
export const DIALOG_DESCRIPTION_CLASS = 'text-[13px] leading-[18px] text-ink';
export const DIALOG_FOOTER_CLASS = 'flex-row items-center justify-end gap-1.5 px-3 pb-3';
export const DIALOG_CANCEL_CLASS =
	'h-8 rounded-full border border-gray-500 bg-white px-4 text-[13px] font-normal text-ink-strong shadow-none hover:bg-gray-100';
export const DIALOG_CONFIRM_CLASS = 'h-8 rounded-full border-0 bg-ink px-4 text-[13px] font-normal text-gray-50 shadow-none hover:bg-ink-strong';
export const DIALOG_DANGER_CLASS = 'h-8 rounded-full border-0 bg-red-500 px-4 text-[13px] font-normal text-white shadow-none hover:bg-red-600';
